import strings from '../../strings';
import wrapInObserver from '../wrapInObserver';
import CheckSelect from './CheckSelect';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import firmTypesEnum from '../../constants/firmTypes';
import { groupIds } from '../../constants/uiParams';

const { useUiStore, useRootStore } = generatedHooks;

const titles = {
  [firmTypesEnum.Carrier]: strings.carrier,
  [firmTypesEnum.Forwarder]: strings.forwarder,
  [firmTypesEnum.Shipper]: strings.shipper,
  [firmTypesEnum.Dispatcher]: strings.dispatcher,
  [firmTypesEnum.ForwarderCarrier]: strings.forwarderCarrier,
  [firmTypesEnum.ShipperCarrier]: strings.shipperCarrier,
};

const allGroupTitles = {
  [groupIds.Dispatcher]: strings.allDispatchers,
  [groupIds.Shipper]: strings.allShippers,
};

const makeSelectFormat = firmTypes => firmTypes.map(firmType => ({ text: titles[firmType], value: firmType }));

const mapProps = () => {
  try {
    const uiStore = useUiStore(store => store);
    const rootStore = useRootStore(store => store);

    const {
      firmTypes,
      groupId,
      groupFirmTypes,
      setFirmTypes,
      dropdownWidth,
    } = uiStore;

    const allGroupTitle = allGroupTitles[groupId];

    const options = makeSelectFormat(groupFirmTypes);
    const selectedValues = makeSelectFormat(firmTypes);

    const handleCheckSelectChange = (checked, data) => {
      const ids = data.array.map(o => o.value);
      setFirmTypes(ids);
      rootStore.reload();
    };

    return {
      options,
      values: selectedValues,
      allGroupTitle,
      handleCheckSelectChange,
      dropdownWidth,
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};

export default wrapInObserver(CheckSelect, mapProps);
